import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const apiContaCorrente = axios.create({
  baseURL: config.REACT_APP_HOST_API_CONTA_CORRENTE || "http://localhost:3028",
});

apiContaCorrente.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiContaCorrente.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async function (error) {
    // Não fazer logout automático em caso de erro 401, deixar o componente tratar
    if (error?.response?.status === 401) {
      console.error('Erro de autenticação na API de conta corrente:', error);
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// APIs REAIS
// ============================================================================

// Listar Clientes com Saldos
export function listarClientesContaCorrente(params = {}) {
  return apiContaCorrente.get("/api/conta-corrente/clientes", { params });
}

// Detalhes da Conta Corrente
export function buscarDetalhesContaCorrente(cnpj) {
  const cnpjLimpo = cnpj?.replace(/\D/g, '') || cnpj;
  return apiContaCorrente.get(`/api/conta-corrente/${cnpjLimpo}`);
}

// Validar Compensação
export function validarCompensacao(body) {
  return apiContaCorrente.post("/api/conta-corrente/validar-compensacao", body);
}

// Criar Lançamento de Débito
export function criarLancamentoDebito(body) {
  return apiContaCorrente.post("/api/conta-corrente/lancar-debito", body);
}

// Receber Crédito (para integração com aprovação de prévias)
export function receberCredito(body) {
  return apiContaCorrente.post("/api/conta-corrente/creditos", body);
}


